import { TDevice } from '@cian/utils';

import { ESiteType } from '../../types/analytics/sopr1';

export const getSiteType = (deviceType: TDevice): ESiteType =>
  deviceType === 'phone' ? ESiteType.mobile : ESiteType[deviceType];
